module.exports = __webpack_public_path__ + "img/standard.395a6189.png";